export default "__VITE_ASSET__Bkng0wtN__"